require('./stepsView.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ actions
const RASuitabilityTestWizardActions = require('actions/RASuitabilityTestWizardActions');
const formActions = require('react-redux-form').actions;
const RASuitabilityTest = require('actions/RASuitabilityTest');
// @ components
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
const RAInvestmentHorizonSlider = require('components/RAComponents/commons/RAInvestmentHorizonSlider/RAInvestmentHorizonSlider');
const RAModal = require('components/RAComponents/commons/RAModal/RAModal');
// @ utilities
import { formatText } from 'core/i18n';
const UtagHelper = require('utilities/utagHelper');
// @ constants
const { PATH_ROBO_TI, PATH_GBI_TI } = require('constants/uTagConstants/paths');
const { SUITABILITY_TEST_PROFILE_MODEL_ANSWERS, SUITABILITY_TEST_STEP_6 } = require('constants/RAConstants');
const {
    TEST_PROCESS_STEP_STEP_6,
    EVENT_CATEGORY_SUITABILITY_TEST,
    EVENT_DETAIL_QUESTION_LOAD,
    EVENT_DETAIL_MODAL_STEP_6,
    EVENT_DETAIL_MODAL_OPEN_DEFAULT,
    EVENT_DETAIL_RECONSIDER_BUTTON,
    EVENT_DETAIL_BUTTON_CLOSE,
    EVENT_DETAIL_VERIFY_MODAL,
    EVENT_DETAIL_VERIFY,
    EVENT_DETAIL_CLICK_INPUT,
    EVENT_DETAIL_TOOLTIP,
    EVENT_DETAIL_BUTTON_PREV,
    EVENT_DETAIL_BUTTON_NEXT,
} = require('constants/uTagConstants/RAConstants');
const { ROBO } = require('constants/userProfile');
const iconVerification = require('assets/icons/icono_verificacion_respuesta.svg');

class RAInvestmentHorizonStepComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };

        this.onHandleContinueButton = this.onHandleContinueButton.bind(this);
        this.onHandlePrevButton = this.onHandlePrevButton.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.onSliderValueChange = this.onSliderValueChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const { userProfile, RATestWizard, raSuitabilityTest } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionID = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;

        if (userProfile?.RASuitabilityTest?.answers?.[questionID]) {
            raSuitabilityTest.validateStep(SUITABILITY_TEST_STEP_6);
        }

        this.recordEvent(EVENT_DETAIL_QUESTION_LOAD);
    }

    onHandleContinueButton() {
        const { RATestWizard, immSuitabilityTest, raSuitabilityTestWizardActions, userProfile } = this.props;
        const step = RATestWizard.currentStep;
        const substep = RATestWizard.currentSubStep;
        const { lastSubStep } = RATestWizard;
        const finalized = RATestWizard.steps?.[step].steps?.[substep].finished;
        const data = {
            step,
            substep,
        };

        if (immSuitabilityTest.getIn(['coherenceError', 'allowToPass']) && this.hasSelectedOption()) {
            if (finalized) {
                raSuitabilityTestWizardActions.nextStep(data);
            } else if (lastSubStep) {
                raSuitabilityTestWizardActions.finishStep(data);
            } else {
                raSuitabilityTestWizardActions.finishSubStep(data);
            }
            const questionID = RATestWizard.steps?.[step].steps?.[substep].question;
            this.recordEvent(`${EVENT_DETAIL_BUTTON_NEXT}, ${userProfile?.RASuitabilityTest?.answers?.[questionID]}`);
        } else {
            this.recordEvent(`${EVENT_DETAIL_MODAL_STEP_6} ${EVENT_DETAIL_MODAL_OPEN_DEFAULT}`);
            this.setState({ showModal: true });
        }
    }

    onHandlePrevButton() {
        const { RATestWizard, raSuitabilityTestWizardActions } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const data = {
            currentStep,
            currentSubStep,
        };

        raSuitabilityTestWizardActions.prevStep(data);
        this.recordEvent(EVENT_DETAIL_BUTTON_PREV);
    }

    onSliderValueChange(value) {
        const { formActions, RATestWizard, raSuitabilityTest } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionId = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;

        formActions.change(`${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.${questionId}`, value);
        this.recordEvent(value);
        raSuitabilityTest.updateTemporalHorizonValue(value);
        raSuitabilityTest.validateStep(SUITABILITY_TEST_STEP_6);
    }

    hasSelectedOption() {
        const { RATestWizard, userProfile } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionID = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;

        return !!userProfile?.RASuitabilityTest?.answers?.[questionID];
    }

    toggleModal() {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
        }));
    }

    recordEvent = (eventDetail = '', eventCategory = EVENT_CATEGORY_SUITABILITY_TEST) => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(pathForTag, eventCategory, TEST_PROCESS_STEP_STEP_6, eventDetail, userProfile);
    };

    recordEventInputClick = (eventDetail = EVENT_DETAIL_CLICK_INPUT) => {
        this.recordEvent(eventDetail);
    };

    recordEventTooltipClick = () => {
        this.recordEvent(EVENT_DETAIL_TOOLTIP);
    };

    getContent() {
        const { immSuitabilityTest } = this.props;
        const immAnswers = immSuitabilityTest.get('answers');
        const investmentHorizonSliderValue = immAnswers.get('218');
        const immQuestions = immSuitabilityTest.get('questions');
        const investmentHorizonSliderTitle = immQuestions.getIn(['218', 'title']);

        return (
            <RAInvestmentHorizonSlider
                sliderValue={investmentHorizonSliderValue}
                titleText={investmentHorizonSliderTitle}
                updateInvestmentHorizonSlider={this.onSliderValueChange}
                disabled={false}
                recordEventInputClick={this.recordEventInputClick}
                recordEventTooltipClick={this.recordEventTooltipClick}
            />
        );
    }

    getModal() {
        const { immSuitabilityTest, raSuitabilityTestWizardActions } = this.props;
        const modalProps = {
            show: this.state.showModal,
        };
        const message = immSuitabilityTest.getIn(['coherenceError', 'message']);
        let modal;

        if (!this.hasSelectedOption()) {
            modalProps.title = formatText('raModal-investmentHorizonModalTitle');
            modalProps.text = formatText('raModal-investmentHorizonModal');
            modalProps.firstButton = formatText('raModal-continueButton');
            // Pass with warnings
            modalProps.firstAction = () => {
                raSuitabilityTestWizardActions.finishSubStep({
                    step: 1,
                    substep: 1,
                });
            };
            modalProps.secondButton = formatText('raModal-reconsiderButton');
            modalProps.secondAction = () => {
                this.recordEvent(`${EVENT_DETAIL_MODAL_STEP_6} ${EVENT_DETAIL_RECONSIDER_BUTTON}`);
                this.toggleModal();
            };

            modalProps.hide = () => {
                this.recordEvent(`${EVENT_DETAIL_MODAL_STEP_6} ${EVENT_DETAIL_BUTTON_CLOSE}`);
                this.toggleModal();
            };

            modal = <RAModal {...modalProps} />;
        } else if (message) {
            modalProps.logo = iconVerification;
            modalProps.title = formatText('raModal-title');
            modalProps.text = message;
            modalProps.firstButton = formatText('raModal-verifyButton');
            modalProps.firstAction = () => {
                this.recordEvent(`${EVENT_DETAIL_VERIFY_MODAL} ${EVENT_DETAIL_VERIFY}`);
                this.toggleModal();
            };
            modalProps.hide = () => {
                this.recordEvent(`${EVENT_DETAIL_VERIFY_MODAL} ${EVENT_DETAIL_BUTTON_CLOSE}`);
                this.toggleModal();
            };

            modal = <RAModal {...modalProps} />;
        }

        return modal;
    }

    render() {
        const { RATestWizard, userProfile } = this.props;

        const content = this.getContent();
        const modal = this.getModal();
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionID = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;
        const disabled = !userProfile.RASuitabilityTest.answers[questionID];

        return (
            <div>
                <div className="steps-view">
                    {content}
                    {modal}
                </div>
                <hr />
                <div className="steps-view__footer">
                    <RoadmapNavigation
                        buttonContinueType="submit"
                        buttonContinueAction={this.onHandleContinueButton}
                        buttonContinueText={formatText('suitabilityTest-next')}
                        buttonPrevText={formatText('suitabilityTest-prev')}
                        buttonCancelText={formatText('suitabilityTest-getOut')}
                        buttonPrevAction={this.onHandlePrevButton}
                        buttonContinueDisabled={disabled}
                    />
                </div>
            </div>
        );
    }
}

export const RAInvestmentHorizonStep = connect(
    state => ({
        userProfile: state.userProfile,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
        products: state.products,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        raSuitabilityTestWizardActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        raSuitabilityTest: bindActionCreators(RASuitabilityTest, dispatch),
    })
)(RAInvestmentHorizonStepComponent);
